import { useEffect, useLayoutEffect, useRef, useState } from "react";
import React from "react";
import isNull from "../../../utils/NullChecking";
import styles from './SuperSearch.module.css'
import { ServerRequestProtected } from "../../../utils/ServerDataRequest";
import { enumUtil } from "../../../utils/Enum";
import NotificationHandler from "../../../utils/NotificationHandler";
import AmountFormatter from "../../../utils/AmountFormatter";
import { useSelector } from "react-redux";
import HandleStatus from "../HandleStatus";
import InitialLetters from "../../../utils/InitialLetters";
import { isMale, isFemale } from "../../../utils/Gender";
import ContentReceiver from "../../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver";
import { GeneralDropDowns } from "../../../actions/GeneralPatientActions";
import { useDispatch } from "react-redux";
import { ViewEncounterIcon } from "../IconsComponent/icons";
import { MainTabContentActiveTab, MainTabContentTabList } from "../../../actions/SidebarAction";
import Patient from "../../Patient/Patient";

const SuperSearchList = (props) => {

    // props.ScrollOutside (true) to disable Oustside Scroll and flip options

    const [openTab, setOpenTab] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [noResult, setNoResult] = useState(false);
    const [noResponse, setnoResponse] = useState(false);
    const inputRef = useRef(null);
    const myDivRef = useRef(null);
    const listRef = useRef(null);
    const listRefGlobal = useRef(null);
    const [selectedData, setSelectedData] = useState(0)
    const [oldValue, setOldValue] = useState('');
    const [multipleOptions, setmultipleOptions] = useState([]);
    const [isItemSelected, setisItemSelected] = useState(false)
    const [initialSelectedItemIndex, setInitialSelectedItemIndex] = useState(-1);
    const [isFocused, setIsFocused] = useState(false)
    const handleScroll = (index) => {
        const list = props.GlobalInst === true ? listRefGlobal.current : listRef.current;
        if (list) {
            const listItems = list.querySelectorAll('#ul-list-for-auto li');
            if (listItems && listItems[index]) {
                const selectedElement = listItems[index];
                // Use scrollIntoView to ensure the selected element is visible
                selectedElement.scrollIntoView({ block: 'nearest' });
            }
        }
    };
    useEffect(() => {
        // debugger
        const abortController = new AbortController();
        if (!isNull(props.searchValue)) {
            if (!isNull(props.data) && props.data.length > 0) {
                const initialIndex = props.data.findIndex(
                    (item) => (item.value === props.searchValue || item.display === props.searchValue)
                );
                if (initialIndex !== -1) {
                    handleScroll(initialIndex)
                    setInitialSelectedItemIndex(initialIndex);
                }
            }
            if (props.searchValue !== oldValue && props.is === false) {
                if (props.searchValue.length > 0) {
                    if (props.type === 'client') {
                        if (props.data !== undefined && props.data.length > 0) {
                            try {
                                let newList = [];
                                for (var i = 0; i < props.data.length; i++) {
                                    if (!isNull(props.data[i].display)) {
                                        if (props.filterWith) {
                                            if (props.filterWith === "startsWith") {
                                                if (props.data[i].display.startsWith(props.searchValue.toUpperCase())) {
                                                    newList = [...newList, props.data[i]];
                                                }
                                            }
                                        } else {
                                            let refinementDisplay = props.data[i].display.toLowerCase();
                                            if (refinementDisplay.includes(props.searchValue.toLowerCase())) {
                                                newList = [...newList, props.data[i]];
                                            }
                                        }
                                    }
                                }
                                setOptions(newList)
                                setNoResult(true)
                            } catch { }
                        }
                    }
                    else if (props.type === 'server') {
                        let response = '';
                        if (props.searchValue.length >= (props.searchValueMinChar || 2)) {
                            setIsLoading(prevLoading => { return true; });
                            (async () => {
                                try {
                                    if (props.method === "post") {
                                        // if postBody prop is not defined
                                        if (!props.postBody) {
                                            throw "Post Body prop is not defined"
                                        }
                                        else {
                                            response = await ServerRequestProtected(props.ApiLink, props.method, props.postBody, abortController.signal)
                                            setIsLoading(() => (false));
                                        }

                                    } else if (props.method === "get") {
                                        response = await ServerRequestProtected(`${props.ApiLink}${props.searchValue}`, props.method, null)
                                    }
                                    else {
                                        throw "Method not allowed";
                                    }
                                    if (response.hasOwnProperty('data')) {
                                        setOptions(response.data)
                                        if (response.data.length > 0) { setNoResult(true) } else { setNoResult(false) }
                                    } else {
                                        setOptions(response)
                                        if (response.length > 0) { setNoResult(true) } else { setNoResult(false) }
                                    }
                                } catch (error) {

                                    setIsLoading(() => (false));
                                    error.code === "ERR_CANCELED" ? setnoResponse(false) : setnoResponse(true)
                                    setNoResult(false)
                                    NotificationHandler(error, enumUtil.enumtoaster.warning)
                                }
                            })();
                        }

                        if (response !== undefined && response.length > 0) {
                            try {
                                let newList = [];
                                for (var i = 0; i < response.length; i++) {
                                    if (!isNull(response[i].ID)) {
                                        if (props.filterWith) {
                                            if (props.filterWith === "startsWith") {
                                                if (response[i].ID.startsWith(props.searchValue.toUpperCase())) {
                                                    newList = [...newList, response[i]];
                                                }
                                            }
                                        } else {
                                            let refinementDisplay = response[i].ID.toLowerCase();

                                            if (refinementDisplay.includes(props.searchValue.toLowerCase())) {
                                                newList = [...newList, response[i]];
                                            }
                                        }
                                    }
                                }
                                setOptions(newList)
                                setNoResult(true)
                            } catch { }
                        }
                    }
                }
            }
        } else {
            if (props.type === 'client') { }
            setOptions(props.data)
        }
        return () => { abortController.abort(); };
    }, [props.searchValue, isFocused]) // isFocused to scroll into view of the selected item 
    let disableScroll = false;
    useEffect(() => {
        if (!props?.ScrollOutside) return;

        if ((!listRefGlobal?.current || !(options?.length > 0))) return;
        const handleScroll = (e) => {
            if (!listRefGlobal.current.contains(e.target)) {
                e.preventDefault();
            }
        }
        if (isFocused) {
            // Disable scrolling on the body if target is outside list
            document.body.style.overflow = "hidden";
            document.addEventListener("wheel", handleScroll, { passive: false });
        } else {
            // Re-enable scrolling on the body
            document.body.style.overflow = "auto";
            document.removeEventListener("wheel", handleScroll);
        }
        // Cleanup on component unmount
        return () => {
            document.body.style.overflow = "auto";
            document.removeEventListener("wheel", handleScroll);
        };
    }, [options, isFocused])
    
    const handleChange = (e) => {
        setInitialSelectedItemIndex(0)
        setisItemSelected(false)
        setnoResponse(false)
        props.onChange(e)
        handleInputChange(e)
    }
    let counter = initialSelectedItemIndex != -1 ? initialSelectedItemIndex : 0; // to maintain the index 
    let bool;  // to check if the arrow is changed from down to up or from up to down (so we should inc or dec)
    let lastKeyPressed; // to check weather counter should be incremented or decremented

    const [isTabPressed, setIsTabPressed] = useState(false);
    const onKeyDownPressed = (e) => {
        if (e.keyCode === 40) {   // onDownkeyPress
            // debugger
            if (bool === false) {
                counter = counter + 2
            }
            handleScroll(counter);
            lastKeyPressed = e.keyCode
            if (options[counter] !== undefined) {
                if (counter <= options.length) {
                    const listItems = document.querySelectorAll('#ul-list-for-auto li');
                    listItems.forEach(function (item, index) {
                        if (index === counter) {
                            item.classList.add(styles.sup_DU);
                        } else {
                            item.classList.remove(styles.sup_DU);
                        }
                    });
                    counter = counter + 1
                    bool = true
                }
            }
        }
        if (e.keyCode === 38) {     // onUpkeyPress
            if (bool === true) {
                counter = counter - 2
            }
            handleScroll(counter);
            lastKeyPressed = e.keyCode
            if (options[counter] !== undefined) {
                if (counter <= options.length) {
                    const listItems = document.querySelectorAll('#ul-list-for-auto li');
                    listItems.forEach(function (item, index) {
                        if (index === counter) {
                            item.classList.add(styles.sup_DU);
                        } else {
                            item.classList.remove(styles.sup_DU);
                        }
                    });
                    counter = counter - 1
                }
                bool = false
            }
        }
        if (e.keyCode === 13) // User pressed the ENTER key
        {
            setisItemSelected(true)
            let index = counter;
            if (lastKeyPressed === 40) {
                index = index - 1  // onDownkeyPress
            } else if (lastKeyPressed === 38) {
                index = index + 1  // onUpkeyPress
            }
            if (options.length > 0) {
                props.getSelectedData(options[index], props.name, props.type)
                setOldValue(options[index].display)
                setNoResult(false)
                setOptions([])
            } else {
                handleonBlur(e)
            }
            // handleScroll(counter);
        }
        if (e.keyCode === 27) { // IF USER PRESSES ESC KEY THEN RESET THE COMPONENT TO ITS ORIGINAL STATE
            props.getSelectedData(null)
            setOptions([])
            setNoResult(!noResult)
            setSelectedData(0)
        }
        if (e.keyCode === 9) {
            // IF USER PRESSES THE TAB BUTTON
            setIsTabPressed(true);
            if (options && options?.length === 1) {
                handleSingleRow(options[0], 0)
            } else {
                handleonBlur();
            }
        }
    }
    let dispatch = useDispatch();
    let GenDD = useSelector(state => state.GeneralDropDownsReducer);


    const handleSingleRow = (singlerow, index, type, isGlobalSearch) => {
        if (isGlobalSearch && singlerow.Type === 'Patient') {
            dispatch(GeneralDropDowns({
                ...GenDD, DisCardActiveIds: {
                    ...GenDD?.DisCardActiveIds,
                    Patient: [...GenDD?.DisCardActiveIds.Patient, {
                        isDemographicsOpened: false,
                        isDemographicsUpdated: false,
                        isInsuranceOpened: false,
                        isInsuranceUpdated: false,
                        PatientID: singlerow.Field1,
                    }]
                }
            }))
        }
        if (type === 'Rem') {
            props.getSelectedData(singlerow, props.name, props.type, props.mode) //props.name added to handle saveupdate
        } else if (props.mode === 'multiple') {
            if (!multipleOptions.includes(singlerow) && multipleOptions.length < 3) {
                const updatedList = [...multipleOptions, singlerow];
                setmultipleOptions(prevState => [...prevState, singlerow])
                props.getSelectedData(updatedList, props.name, props.type) //props.name added to handle saveupdate
            }
        } else {
            setOldValue(singlerow.display)
            props.getSelectedData(singlerow, props.name, props.type, props?.index, props?.recordID) //props.name added to handle saveupdate
        }
        setisItemSelected(true)
        setNoResult(false)
        setSelectedData(index)
        handleScroll(index);
    }
    const resetComponent = (e) => {
        props.getSelectedData(null, props.name, props.type)
        setOptions([])
        setNoResult(false)
    }
    const handleMouseDown = (e) => {
        if (isFocused) {
            inputRef.current.blur();
        } else {
            e.preventDefault();
            inputRef.current.focus();
        }
    }
    const handleOnClick = (e) => {
        if (props.GlobalInst === true) { props.setIsFocused(true) }
        setisItemSelected(true);
        setIsFocused(!isFocused)
        if (!isNull(props.data)) {
            setOptions(props.data)
            setNoResult(!noResult)
            handleParentClick(e);
        } else {
        }
        if (props.handleonFocus) {
            props.handleonFocus()
        }
    }
    const handleOnFocus = (e) => {
        handleOnClick(e);
    }
    const handleonBlur = (e) => {
        setIsTabPressed(false);
        if (props.GlobalInst === true) { props.setIsFocused(false) }
        setIsFocused(false)
        if (isTabPressed) {

        } else {
            if (!isNull(e)) {
                let { value, name } = e.target
                setNoResult(false)
                setnoResponse(false)
                if (props.handleOnblur) {
                    props.handleOnblur(value, name)
                }
                if (isItemSelected === false) {
                    props.getSelectedData(null, props.name, props.type)
                }
            }
        }
    }
    const handleRemoveItem = (index) => {
        const updatedLista = [...multipleOptions];
        updatedLista.splice(index, 1);
        setmultipleOptions(updatedLista);
        handleSingleRow(updatedLista, index, 'Rem')
    }
    const handleonBlurDiv = (e) => {
        if (!myDivRef.current.contains(e.relatedTarget)) {
            setIsFocused(false)
            setNoResult(false)
            setnoResponse(false)
        }
    }
    const handleSearch = () => {
        if (!isNull(props.handleOnClickSearch)) {
            props.handleOnClickSearch()
        }
    }
    const handleCommonKeyDown = (e) => {
        // Then, handle the common logic used for both the input and the div
        if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Enter") {
            onKeyDownPressed(e)
            e.preventDefault(); // Prevent default behavior for ArrowUp/ArrowDown/Enter
        }
    };
    const onMouseEnterHower = () => {
        const listItems = document.querySelectorAll('#ul-list-for-auto li');
        listItems.forEach(function (item, index) {
            item.classList.remove(styles.sup_DU);
        });
    }

    const handleOpenPatientsClaims = (e, data) => {
        e.stopPropagation();
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "All Claims",
                id: 0,
                time: new Date(),
                visitType: {
                    type: 'ClaimSearch',
                    PatientID: String(data.Field1),
                    PatientName: data.Field2,
                },
            },
        };
        setOpenTab(dataObj)
    }
    //////Open Encounter ///////
    let state = useSelector(state => state.SidebarList)
    const handleActive_SubTab = (key, name, component, right) => {
        let arr = state
        let dynamicTabs = [...arr]
        const newTabObject = {
            key: key,
            name: name,
            component: component,
            right: right,
            time: new Date(),
        }
        const isTabExist = dynamicTabs.filter((tab) => {
            return tab.name === name
        })
        if (!(isTabExist && isTabExist.length > 0)) {
            dynamicTabs = [...dynamicTabs, newTabObject]
            dispatch(MainTabContentTabList(dynamicTabs));
        }
        dispatch(MainTabContentActiveTab(key))
        // setOpenTab && setOpenTab('')
    }
    const handleOpenPatientsEncounter = (e, type, item) => {
        e.stopPropagation();
        handleActive_SubTab(2, 'Patient', <Patient />, true)
        dispatch({
            type: 'OPEN_PATIENT_WITH_ENCOUNTER_TAB',
            payload: {
                patientTab: {
                    active: true,
                    key: 2,
                    name: "Patient",
                    data: { id: item.Field1, name: item.Field2, type: "Encounter", },
                    // other patient tab props
                },
                encounterTab: {
                    active: true,
                    key: 2,
                    name: "Encounter",
                    data: {
                        id: 0, name: "All Encounter", time: new Date(),
                        AddEncounterPopup: {
                            active: true,
                            data: {
                                Action: 'ApplyDemoData',
                            }
                        }
                    },
                }
            }
        })
    }

    /* /////////////////==== Global Instant Search Response ====/////////////////// */
    const GlobalInstantSearchOptions = ({ index, item }) => {
        let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
        const isHomeCareCheck = DropDowns.IsHomeCare;
        return (<>
            <li className=" za-supercard za-br-tb global-search-items"
                key={index}
                onMouseDown={() => handleSingleRow(options[index], index, '', true)}
                // onMouseDown={() => handleSingleRow(item, index)}
                onMouseEnter={onMouseEnterHower}
                // onMouseLeave={() => setHoveredItemIndex(-1)}
                id={index}>
                {item.Type === 'Patient' ?
                    <>
                        <div className='d-flex gap-1 align-items-center w-100 type-pat'>
                            <div className='w-100 overflow-hidden '>
                                <div className='d-flex align-items-center mb-1'>
                                    <div className='d-flex align-items-center gap-1 col-md-11'>
                                        <i className="icon-icon-experience fs-11 ar-dark-color"></i>
                                        <SearchLetterHighlighted classes={'heading lh-remove text-nowrap validation_message'} searchValue={props.searchValue} text={item.Field2} />
                                        <SearchLetterHighlighted classes={'text fs-11 ar-light-color'} searchValue={props.searchValue} text={item.Field8} />
                                        <p className='text fs-11 ar-light-color'>({item.Field3})</p>
                                        <p className='text fs-11 ar-light-color'>{item.Field9} -</p>
                                        <SearchLetterHighlighted classes={'text fs-11 ar-light-color'} searchValue={props.searchValue} text={item.Field6} />
                                    </div>
                                    <div className="col-md-1 d-flex gap-1 justify-content-end align-items-center">

                                        <div class="app_tooltip left" onMouseDown={(e) => { handleOpenPatientsClaims(e, options[index]); }} >
                                            <span class="icon-pateintclaim fs-15 br-clr-light" ><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>
                                            <p className="tool_tip xsm_text text-light">View Claims</p>
                                        </div>
                                        <div className="spreater"></div>
                                        <div class="app_tooltip left" onMouseDown={(e) => { handleOpenPatientsEncounter(e, "New Encounter", item); }} >
                                            <ViewEncounterIcon />
                                            <p className="tool_tip xsm_text text-light">Create Encounter</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center mb-06-px">
                                    <div className="col-md-7">
                                        {item.Field10 ?
                                            (item.Field10 !== "No Insurance Recorded" ? (
                                                <SearchLetterHighlighted
                                                    classes="text font-m fs-11 fst-italic drk-green-clr singleLine-ellispis"
                                                    searchValue={props.searchValue}
                                                    text={item.Field10}
                                                />
                                            ) : (
                                                <p className="text fs-11 light-clrs fst-italic">No Insurance Recorded</p>
                                            ))
                                            :
                                            <p className="text fs-11 light-clrs fst-italic">No Insurance Recorded</p>
                                        }


                                    </div>
                                    <div className="col-md-5 text-end">
                                        {item.Field5 ?
                                            <SearchLetterHighlighted classes={'text ar-light-color fs-11 '} searchValue={props.searchValue} text={item.Field5} type={'PhoneNumber'} />
                                            :
                                            <p className='text fs-11 light-clrs fst-italic'>N/A</p>
                                        }
                                        {/* <p className='text font-m fs-11 drk-green-clr'>{PhoneNumberFormat(item.Field5)}</p> */}
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className='d-flex gap-1 col-md-6'>

                                        <p className='text fs-11 text-nowrap font-m ar-light-color'>Subcriber ID:</p>
                                        {item.Field7 ?
                                            <SearchLetterHighlighted classes={'text fs-11 text-nowrap validation_message ar-light-color'} searchValue={props.searchValue} text={item.Field7} />
                                            :
                                            <p className='text fs-11 light-clrs fst-italic'>N/A</p>
                                        }
                                        {/* <p className='text fs-11 text-nowrap validation_message'>{item.Field7}</p> */}

                                    </div>
                                    {isHomeCareCheck === 'true' ?
                                        <>
                                            {item.Field14 ?
                                                <div className='d-flex gap-1 col-md-6 justify-content-end'>
                                                    <p className='text fs-11 text-nowrap font-m ar-light-color'>Medicaid #</p>
                                                    <SearchLetterHighlighted classes={'text fs-11 text-nowrap validation_message ar-light-color'} searchValue={props.searchValue} text={item.Field14} />
                                                    {/* <p className='text fs-11 font-m text-nowrap validation_message'>{item.Field14}</p> */}
                                                </div> : <></>}
                                        </>
                                        :
                                        <div className=' d-flex gap-1 justify-content-end col-md-6'>
                                            <p className='text fs-11 za-pat-copay pat-bal text-nowrap'>Pat Bal:  <AmountFormatter amount={item.Field11} /></p>
                                            <p className='text fs-11 za-pat-copay copay text-nowrap'>Copay:  <AmountFormatter amount={item.Field12} /></p>
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </> :
                    item.Type === 'Claim' ?
                        <>
                            <div className='d-flex gap-1 align-items-center'>
                                <div className="w-100 over-flow-hidden">
                                    <div className="d-flex align-items-center mb-1">
                                        <div className="d-flex align-items-center gap-1 col-md-10">
                                            <div class="app_tooltip right" onMouseDown={(e) => { handleOpenPatientsEncounter(e, "New Encounter", item); }} >
                                                <span class="icon-pateintclaim fs-14 br-clr-light"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>
                                            </div>
                                            <p className='heading lh-remove'>Claim # <span className="font-m">{item.Field1}</span></p>
                                        </div>
                                        <div className="col-md-2 d-flex justify-content-end">
                                            <p className={`heading fs-11 text-bg-M d-flex justify-content-center align-items-center lh-11 ${item.Field7 === "I" ? 'Institutional-bg' : ''}`}>{item.Field7}</p>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center mb-06-px">
                                        <div className="d-flex align-items-center gap-1 col-md-8">
                                            {item.Field3 ?
                                                (item.Field3 !== "No Insurance Recorded" ? (
                                                    <p title={item.Field3} className='text font-m fs-11 fst-italic drk-green-clr validation_message text-nowrap za-claims w-100'>{item.Field3}</p>
                                                ) : (
                                                    <p className="text fs-11 light-clrs fst-italic">No Insurance Recorded</p>
                                                ))
                                                :
                                                <p className="text fs-11 light-clrs fst-italic">No Insurance Recorded</p>
                                            }
                                        </div>

                                        <div className="col-md-4 d-flex justify-content-end">
                                            <HandleStatus Status={item?.Field6} />
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center">
                                        <div className="d-flex align-items-center gap-1 col-md-5">
                                            <p className='text fs-11 text-nowrap font-m ar-light-color'>Patient:</p>
                                            {item.Field2 ?
                                                <p className='text fs-11 ar-light-color singleLine-ellispis' title={item.Field2}>{item.Field2}</p>
                                                :
                                                <p className='text fs-11 light-clrs fst-italic'>N/A</p>
                                            }

                                        </div>

                                        <div className="col-md-7">
                                            <div className='d-flex gap-1 justify-content-end '>
                                                <p className='text fs-11 za-bpb billed-bg'>Billed : <AmountFormatter amount={item.Field4} /></p>
                                                <p className='text fs-11 za-bpb paid-bg'>Paid : <AmountFormatter amount={item.Field8} /></p>
                                                <p className='text fs-11 za-bpb bal-bg'>Bal : <AmountFormatter amount={item.Field5} /></p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                {/* <div className=''>
                                    <div className='d-flex align-items-center gap-01'>
                                        <p className='text font-m fs-12'>Claim # {item.Field1}</p>
                                        <p className='heading fs-11 text-bg-M d-flex justify-content-center'>{item.Field7}</p>
                                    </div>




                                </div> */}
                            </div>
                        </> :
                        ["Manual Payment", "ERA Payment"].includes(item.Type) ?
                            <>
                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                    <div className='d-flex align-items-center gap-1'>
                                        <span class="icon-circle-cash fs-11"><span class="path1"></span><span class="path2"></span></span>
                                        <p className='heading lh-remove'>Check # <span className="font-m"> {item.Field2}</span> </p>
                                    </div>
                                    <p className='heading fs-11 text-bg-M d-flex justify-content-center'>{item.Type === "Manual Payment" ? "M" : "E"}</p>
                                </div>
                                <div className='d-flex align-items-center justify-content-between mb-06-px gap-15'>
                                    {item.Field3 ?
                                        <p title={item.Field3} className='text font-m fs-11 fst-italic drk-green-clr validation_message text-nowrap za-claims w-100'>{item.Field3}</p>
                                        :
                                        <p className='text fs-11 light-clrs fst-italic'>No Insurance Recorded</p>
                                    }
                                    {item.Field6 ?
                                        <span className="text-nowrap">
                                            {item.Field6 === 'Posted' ? <span className="pill Paid">{item.Field6}</span> :
                                                item.Field6 === 'Processing' ? <span className="pill pill-Processing">{item.Field6}</span> :
                                                    item.Field6 === 'New' ? <span className="pill  New">{item.Field6}</span> :
                                                        item.Field6 === 'Partially Posted' ? <span className="pill Partialpaid">{item.Field6}</span> :
                                                            item.Field6 === 'Processed' ? <span className='pill pill-success'>{item.Field6}</span> :
                                                                item.Field6 === 'Reviewed' ? <span className="pill In-Review">{item.Field6}</span> :
                                                                    item.Field6 === 'External' ? <span className="pill information-Required">{item.Field6}</span> :
                                                                        item.Field6 === 'Pending' ? <span className='pill pill-danger'>{item.Field6}</span> :
                                                                            <>{item.Field6}</>}
                                        </span>
                                        :
                                        <></>
                                    }
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div className='d-flex gap-1 align-items-center'>
                                        <p className='text fs-11 ar-light-color font-m'>Chk Date:</p>
                                        {item.Field5 ?
                                            <p className='text fs-11 ar-light-color'>{item.Field5}</p>
                                            :
                                            <p className='text fs-11 light-clrs fst-italic'>N/A</p>
                                        }
                                    </div>
                                    <p className='text fs-11 chk-amt-bg'>Chk Amt : <AmountFormatter amount={item.Field4} /></p>
                                </div>
                            </> :
                            ["Location", "Provider", "RefProvider"].includes(item.Type) ?
                                <>
                                    <div className="d-flex gap-1 align-items-center mb-1">
                                        {["Location"].includes(item.Type) ?
                                            <i className='icon-Icon-material-location-on fs-11'></i>
                                            :
                                            ["Provider", "RefProvider"].includes(item.Type) ?
                                                <i className="icon-icon-experience fs-11 ar-dark-color"></i>
                                                : <></>}
                                        <p className='heading lh-remove'>{item.Field2}</p>
                                    </div>
                                    <div className='d-flex gap-1 align-items-center mb-06-px'>
                                        {item.Field3 ?
                                            <>
                                                <p className='text ar-dark-color font-m'>NPI:</p>
                                                <p className='text ar-dark-color font-m fst-italic'>{item.Field3}</p>
                                            </>
                                            :
                                            <p className='text light-clrs fst-italic'>No NPI Recorded</p>
                                        }
                                    </div>
                                    <div className='d-flex gap-1 align-items-center'>
                                        <p className='text ar-light-color font-m'>Phone #</p>
                                        {item.Field4 ?
                                            <p className='text ar-light-color'>{PhoneNumberFormat(item.Field4)}</p>
                                            :
                                            <p className='text light-clrs fst-italic'>N/A</p>}
                                    </div>

                                    {/* <span className="search-dataList__item__date">{item.Field3}</span> */}

                                </>
                                :
                                ["POS", "Diagnosis", "Procedure", "Modifier"].includes(item.Type) ?
                                    <>
                                        <div className="d-flex gap-1 align-items-center mb-1">
                                            <i className='icon-pos'></i>
                                            <p className='heading lh-remove'>{item.Type}: {item.Field2}</p>
                                        </div>
                                        <div className='d-flex gap-6 align-items-baseline'>
                                            {item.Field3 ?
                                                <>
                                                    <p className='text ar-light-color font-m'>Description:</p>
                                                    <p className='text ar-light-color singleLine-ellispis' title={item.Field3}>{item.Field3}</p>
                                                </>
                                                :
                                                <p className='text light-clrs fst-italic'>No Description Recorded</p>}
                                        </div>
                                    </>
                                    :
                                    ["Insurance"].includes(item.Type) ?
                                        <>
                                            <div className="d-flex gap-1 align-items-center mb-1">
                                                <i className='icon-umbrella-solid'></i>
                                                <p className='heading lh-remove singleLine-ellispis' title={`${item.Field4} (${item.Field2})`}>{item.Field4} <span className="fs-11 ar-light-color text">({item.Field2})</span></p>
                                            </div>
                                            <div className='d-flex gap-1 align-items-center mb-06-px'>
                                                <p className='text ar-dark-color font-m'>Insurance Type:</p>
                                                {item.Field4 ?
                                                    <p className='text ar-dark-color font-m fst-italic'>{item.Field5}</p>
                                                    :
                                                    <p className='text fs-11 light-clrs fst-italic'>No Insurance Type Recorded</p>
                                                }
                                            </div>
                                            <div className='d-flex gap-1 align-items-center'>
                                                <p className='text ar-light-color font-m'>Payer ID:</p>
                                                {item.Field3 ?
                                                    <p className='text ar-light-color'>{item.Field3}</p>
                                                    :
                                                    <p className='text light-clrs fst-italic'>N/A</p>}
                                            </div>
                                        </>
                                        :
                                        null}
            </li >
        </>)
    }
    const handleonMouseChange = (e) => {
        setisItemSelected(true)
    }

    const [divStyle, setDivStyle] = useState(() => props.ScrollOutside ? { visibility: 'hidden' } : {});
    const parentRef = useRef(null);

    // Positioning logic
    const updateDropdownPosition = () => {
        if (!parentRef.current || !listRef.current) return;

        const rect = parentRef.current.getBoundingClientRect();
        const dropdownHeight = listRef.current.offsetHeight;
        const dropdownWidth = listRef.current.offsetWidth;
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;

        let top = rect.bottom;
        let left = rect.left;

        // Adjust position if dropdown would go off bottom of screen
        if (rect.bottom + dropdownHeight > viewportHeight) {
            top = rect.top - dropdownHeight;
        }

        // Adjust position if dropdown would go off right of screen
        if (rect.left + dropdownWidth > viewportWidth) {
            left = viewportWidth - dropdownWidth - 10;
        }

        // Ensure dropdown doesn't go off left of screen
        if (left < 0) {
            left = 10;
        }

        setDivStyle({
            top: `${top}px`,
            left: `${left}px`,
            width: `${rect.width}px`,
            position: 'fixed',
            zIndex: 9999,
            visibility: 'visible',
        });
    };

    // Call this whenever the dropdown should be positioned
    const positionDropdown = () => {
        if (props.ScrollOutside) {
            // Force reflow before updating position
            requestAnimationFrame(() => {
                updateDropdownPosition();
            });
        }
    };

    useLayoutEffect(() => {
        if (!props.ScrollOutside) return;
        if (noResult) {
            updateDropdownPosition(); // runs before paint — no visible flip
        } else {
            setDivStyle(prev => ({ ...prev, visibility: 'hidden' }));
        }
    }, [noResult, options]);

    // Call this on parent div click
    const handleParentClick = (e) => {
        if (props.ScrollOutside) {
            positionDropdown();
        }
    };

    // Call this on input change
    const handleInputChange = (e) => {
        // Your existing filtering/search logic here...

        if (props.ScrollOutside) {
            positionDropdown();
        }
    };

    // Add resize and scroll listeners
    useEffect(() => {
        if (!props.ScrollOutside) return;

        const handleResize = () => {
            positionDropdown();
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('scroll', handleResize, true);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleResize);
        };
    }, [props.ScrollOutside]);


    useEffect(() => {
        if (props.focused) {
            inputRef.current.focus();
        }
    }, [props.focused])
    return (
        <div id={`autoSuggestParentDiv_${props.id}`} className={`${styles.sup_auto_suggest} ${styles.insurance_auto} ${props.GlobalInst ? 'ar-input-width' : ''}  ar_single-super-search`} style={{ width: `${props.width}` }} onClick={handleParentClick} ref={parentRef}>
            {multipleOptions.length > 0 ? <>
                {multipleOptions.map((item, index) => {
                    return (
                        <button class="btn btn-orange btn-xs no-width">{item.display} <i className="bi bi-x" onClick={() => handleRemoveItem(index)}></i></button>
                    )
                })}
            </> :
                null}
            <div className={`input-group flex-nowrap ${styles[props.sup_inp]}`}>
                {props.GlobalInst === true ?
                    <div className='field-icon'>
                        {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}

                        <input
                            ref={inputRef}
                            id={'GlobalSearchList'}
                            name={props.name}
                            type="text"
                            // autoComplete="new-password"
                            placeholder={props?.placeholder}
                            className={`${props.inputError ? `col ${styles.sup_yellowsearch_error} ` : `col ${styles.sup_yellowsearch}`} ${props.isReadOnly ? styles.disable_input_design : ''}`}
                            onChange={handleChange}
                            value={props.searchValue}
                            onKeyDown={(e) => {
                                onKeyDownPressed(e);
                            }}
                            onMouseDown={handleonMouseChange}
                            onFocus={handleOnClick}
                            onBlur={handleonBlur}
                            icon={true}
                            readOnly={props.isReadOnly ? true : false}
                        />
                        {isLoading ?
                            <div className='last_loader'>
                                <div className='last_loader ar-small-loader'>
                                    <div class="circle circle1"></div>
                                    <div class="circle circle2"></div>
                                </div>
                            </div> :
                            props.searchValue.length > 0 &&
                            <span className='ar-global-icon'>
                                <i className='icon-Icon-metro-cross'></i>
                            </span>}
                    </div> :
                    <>
                        <input
                            ref={inputRef}
                            id={'GlobalSearchList'}
                            name={props.name}
                            type="text"
                            autoComplete="off"
                            // className={`col ${styles.sup_yellowsearch}`}
                            className={`${props.inputError ? `col ${styles.sup_yellowsearch_error}` : `col ${styles.sup_yellowsearch} `}  ${props.isReadOnly ? styles.disable_input_design : ''} `}
                            // className="col"
                            placeholder={props?.placeholder === false ? "" : props?.placeholder}
                            onChange={handleChange}
                            value={props.searchValue}
                            onKeyDown={(e) => {
                                onKeyDownPressed(e);
                                // handleCommonKeyDown(e);
                            }}
                            onMouseDown={handleonMouseChange}
                            // onClick={handleOnClick}
                            onBlur={handleonBlur}
                            onFocus={handleOnFocus}
                            icon={true}
                            readOnly={props.isReadOnly || props.disableInput ? true : false}
                        // disabled = {props.disableInput}
                        />
                        {props.id === 'ProviderIDAppointment' || props.id === 'PatientAISummary' && !isNull(props.searchValue) ? <i className="icon-Group-3311 position-absolute translate-middle-y top-50" onClick={() => handleSingleRow('')} /> : null}
                    </>
                }
                {props.isReadOnly ? null :
                    <>
                        {!props.disabled ? (
                            props.icon === true ?
                                isLoading ? null :
                                    <div className={`input-group-append ${styles.input_group_append}`} >
                                        {((props.InsuranceInst || props?.PatientDeatailedInst) && props.searchValue) ?
                                            <button onClick={resetComponent} className={`${styles.sup_btn_color} ${styles[props.sup_btn]}`}>
                                                <i className="bi bi-x" style={{ position: 'relative' }} />
                                            </button>
                                            : <button className={`${styles.sup_btn_color} ${styles[props.sup_btn]}`} onClick={handleSearch}>
                                                {' '}
                                                <i className="bi bi-search" style={{ position: 'relative' }} />
                                            </button>
                                        }
                                    </div>
                                : props.icon === 'Simple' ?
                                    <div
                                        className="ar-search-arrow "
                                        onMouseDown={handleMouseDown}
                                        ref={myDivRef}
                                        onBlur={handleonBlurDiv}
                                        // onKeyDown={onKeyDownPressed}
                                        onKeyDown={(e) => {
                                            // onKeyDownPressedForDiv(e);
                                            handleCommonKeyDown(e);
                                        }}
                                        tabIndex={1} // This makes the div focusable
                                    >
                                        {
                                            isFocused ? (
                                                <span className=""><i class="icon-caret-up fs-18"></i></span>
                                            ) : (
                                                <span className=""><i class="icon-caret-down fs-18"></i></span>
                                            )
                                        }
                                    </div>
                                    :
                                    <div className={`search-arrow ${styles.search_arrow}`}
                                        onMouseDown={handleOnClick}
                                        ref={myDivRef}
                                        onBlur={handleonBlurDiv}
                                        // onKeyDown={onKeyDownPressed}
                                        onKeyDown={(e) => {
                                            // onKeyDownPressedForDiv(e);
                                            handleCommonKeyDown(e);
                                        }}
                                        tabIndex={0} // This makes the div focusable
                                    >
                                        {
                                            isFocused ? (
                                                <span className="dropdown_icon up"><i class="icon-caret-up"></i></span>
                                            ) : (
                                                <span className="dropdown_icon"><i class="icon-caret-down"></i></span>
                                            )
                                        }
                                    </div>

                        ) : null}
                    </>
                }

                {isLoading && props.InsuranceInst ?
                    <div className='last_loader position-absolute translate-middle-y top-50 end-12'>
                        <div className='last_loader ar-small-loader'>
                            <div class="circle circle1"></div>
                            <div class="circle circle2"></div>
                        </div>
                    </div> : null
                }
            </div>
            {
                noResult ? (
                    // <div className={props.GlobalInst || props.PatientAppt ? `${styles.sup_listWrapper} ${styles.insurance_list_wrap} za-super-search-list rounded m-1` : `${styles.sup_listWrapper} ${styles.insurance_list_wrap} ${styles.ar_super_serach_multiple} hk-supListBOX`} ref={listRef}  >
                    <div className={props.GlobalInst || props.PatientAppt ? `${styles.sup_listWrapper} ${styles.insurance_list_wrap} ${styles.mousedown_clr}  za-super-search-list rounded m-1` : `${styles.sup_listWrapper} ${styles.insurance_list_wrap} ${styles.ar_super_serach_multiple} hk-supListBOX`} ref={listRef} style={!props.GlobalInst === true ? divStyle : null}>
                        {props.isReadOnly ? null :
                            <>
                                {props.GlobalInst === true ?
                                    <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr'>{options?.length || '0'} Result(s) Found</p> : props.PatientAppt === true ? <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr'>{options?.length - 1 || '0'} Result(s) Found</p> : props.InsuranceInst === true ? <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr px-1-5 br-bottom-1 py-1 za_br_light'>{options?.length || '0'} Result(s) Found</p> : <></>}
                                <ul className={`${(props.GlobalInst || props.PatientAppt) ? 'za-super-search-cards hover-scrollbar ps-0 mb-0' : 'list-group hover-scrollbar '}`} id="ul-list-for-auto" ref={listRefGlobal}>
                                    {options && options.map((item, index) => {
                                        return (<>
                                            {props.GlobalInst === true ?
                                                <GlobalInstantSearchOptions index={index} item={item} />
                                                :
                                                props.PatientAppt === true ?
                                                    <li className={`p-0 ${styles.sup_list_group_item} ${index === initialSelectedItemIndex ? styles.sup_DU : ''}`}
                                                        key={index}
                                                        onMouseDown={() => handleSingleRow(options[index], index, props.additionalData)}
                                                        // onMouseDown={() => handleSingleRow(item, index)}
                                                        onMouseEnter={onMouseEnterHower}
                                                        // onMouseLeave={() => setHoveredItemIndex(-1)}
                                                        id={index}
                                                        tabindex="-1"
                                                    >
                                                        {props.Color === true ? <span className={item.color}></span> : null}
                                                        {item?.value !== "-1" ?
                                                            <div className=' za-supercard za-br-tb'>
                                                                <div className='d-flex gap-1 align-items-center'>
                                                                    <div className="img-container circle s-35">
                                                                        {item?.ProfilePictureURL ?
                                                                            <img src={item?.ProfilePictureURL || ""} /> :
                                                                            <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-male">
                                                                                <InitialLetters classes={""} name={item?.display} splitBy={','} />
                                                                            </p>}
                                                                    </div>

                                                                    <div className='w-100 overflow-hidden '>
                                                                        <div className='d-flex align-items-center'>
                                                                            {/* <span class="icon-searchlist-sumry fs-8"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span> */}
                                                                            <div className='d-flex align-items-end gap-1 col-md-8'>
                                                                                <SearchLetterHighlighted classes={'heading text-nowrap text-nowrap validation_message'} searchValue={props.searchValue} text={item?.display} />
                                                                                <p className='text fs-11 ar-light-color'>{item?.DOB}</p>
                                                                                <p className='text fs-11 ar-light-color'>{item?.Age && `(${item?.Age})`}</p>
                                                                                <p className='text fs-11 ar-light-color'>{item?.Gender === "M" ? 'Male' : item?.Gender === "F" ? 'Female' : 'Other'}</p>
                                                                            </div>
                                                                            <div className="col-md-4 text-end pe-1">
                                                                                <p className='text fs-12 fst-italic font-m ar-light-color'>{item?.AccountNumber}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className='d-flex align-items-center'>
                                                                            <div className='col-md-7'>
                                                                                <p className='text font-m fs-11 fst-italic drk-green-clr'>{item?.InsuranceName}</p>
                                                                            </div>
                                                                            <div className="col-md-5 text-end">
                                                                                <p className='text font-m fs-11 drk-green-clr'>{PhoneNumberFormat(item?.MobileNumber)}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className='d-flex gap-1 col-md-6'>
                                                                                <p className='text fs-11'>Subcriber ID:</p>
                                                                                <p className='text fs-11'>{item?.SubscriberID}</p>
                                                                            </div>

                                                                            <div className=' d-flex gap-1 col-md-6 justify-content-end'>
                                                                                <p className='text fs-11 font-m za-pat-copay pat-bal text-nowrap'>Pat Bal: <AmountFormatter amount={item?.PatBal} /></p>
                                                                                <p className='text fs-11 font-m za-pat-copay copay text-nowrap'>Copay: <AmountFormatter amount={item?.copay} /></p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : null}
                                                    </li>
                                                    : props.PatientPayment === true ?
                                                        <li className={`p-0 ${styles.sup_list_group_item} ${index === initialSelectedItemIndex ? styles.sup_DU : ''}`}
                                                            key={index}
                                                            onMouseDown={() => handleSingleRow(options[index], index, props.additionalData)}
                                                            // onMouseDown={() => handleSingleRow(item, index)}
                                                            onMouseEnter={onMouseEnterHower}
                                                            // onMouseLeave={() => setHoveredItemIndex(-1)}
                                                            id={index}
                                                            tabindex="-1"
                                                        >
                                                            {props.Color === true ? <span className={item.color}></span> : null}
                                                            {item?.value !== "-1" ?
                                                                <div className=' za-supercard za-br-tb'>
                                                                    <div className='d-flex gap-1 align-items-center'>
                                                                        <div className="img-container circle s-35">
                                                                            {item?.ProfilePictureURL ?
                                                                                <img src={item?.ProfilePictureURL || ""} /> :
                                                                                <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-male">
                                                                                    <InitialLetters classes={""} name={item?.display} splitBy={','} />
                                                                                </p>}
                                                                        </div>

                                                                        <div className='w-100 overflow-hidden '>
                                                                            <div className='d-flex align-items-center'>
                                                                                {/* <span class="icon-searchlist-sumry fs-8"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span> */}
                                                                                <div className='d-flex align-items-end gap-1 col-md-8'>
                                                                                    <SearchLetterHighlighted classes={'heading text-nowrap text-nowrap validation_message'} searchValue={props.searchValue} text={item?.display} />
                                                                                    <p className='text fs-11 ar-light-color'>{item?.DOB}</p>
                                                                                    <p className='text fs-11 ar-light-color'>{item?.Age && `(${item?.Age})`}</p>
                                                                                    <p className='text fs-11 ar-light-color'>{item?.Gender === "M" ? 'Male' : item?.Gender === "F" ? 'Female' : 'Other'}</p>
                                                                                </div>
                                                                                {/* <div className="col-md-4 text-end pe-1">
                                                                                    <p className='text fs-12 fst-italic font-m ar-light-color'>{item?.AccountNumber}</p>
                                                                                </div> */}
                                                                            </div>
                                                                            <div className='d-flex align-items-center'>
                                                                                <div className='col-md-7'>
                                                                                    <p className='text font-m fs-11 fst-italic drk-green-clr'>{item?.InsuranceName}</p>
                                                                                </div>
                                                                                <div className="col-md-5 text-end">
                                                                                    <p className='text font-m fs-11 drk-green-clr'>{PhoneNumberFormat(item?.MobileNumber)}</p>
                                                                                </div>
                                                                            </div>
                                                                            <div className="d-flex align-items-center">
                                                                                <div className='d-flex gap-1 col-md-6'>
                                                                                    <p className='text fs-11'>Email:</p>
                                                                                    <p className='text fs-11'>{item?.Email}</p>
                                                                                </div>

                                                                                <div className=' d-flex gap-1 col-md-6 justify-content-end'>
                                                                                    <p className='text fs-11 font-m za-pat-copay pat-bal text-nowrap'>Pat Bal: <AmountFormatter amount={item?.PatBal} /></p>
                                                                                    <p className='text fs-11 font-m za-pat-copay copay text-nowrap'>Copay: <AmountFormatter amount={item?.copay} /></p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                : null}
                                                        </li>
                                                        :
                                                        <div className={`${styles.ar_options_list}`}>
                                                            <li className={`${styles.sup_list_group_item} ${index === initialSelectedItemIndex ? styles.sup_DU + ' ' + styles.ar_slected_list : ''}`}
                                                                key={index}
                                                                onMouseDown={() => handleSingleRow(options[index], index)}
                                                                // onMouseDown={() => handleSingleRow(item, index)}
                                                                onMouseEnter={onMouseEnterHower}
                                                                // onMouseLeave={() => setHoveredItemIndex(-1)}
                                                                id={index}
                                                            >
                                                                {props.Color === true ? <span className={item.color}></span> : null}
                                                                {props?.AppointmentStatus ?
                                                                    <div className={`${styles.ar_all_options + " " + item?.ColorCode.replace('#', 'color-')}`}>
                                                                        {item.value === -1 ? '' : item.display}
                                                                    </div> :
                                                                    props?.EncounterStatus ?
                                                                        <div className={`${styles.ar_all_options + " " + item?.ColorCode.replace('#', 'color-')}`}>
                                                                            {item.value === -1 ? '' : item.display}
                                                                        </div>

                                                                        : props?.IsCLMInsurance ?
                                                                            <div className={`${styles.ar_all_options} text  ${item.Active === 'false' ? styles.ar_red_insurance : null}`}>
                                                                                {item.value === -1 ? '' : item.CoveragePriority === 'P' ? `${'PRI - ' + item.display}` :
                                                                                    item.CoveragePriority === 'S' ? `${'SEC - ' + item.display}` :
                                                                                        item.CoveragePriority === 'T' ? `${'TER - ' + item.display}` : `${item.display}`
                                                                                }
                                                                            </div> :
                                                                            (props.InsuranceInst || props.PatientDeatailedInst) ? null : (
                                                                                <div className={`${styles.ar_all_options} text d-flex justify-content-between align-items-center `}>
                                                                                    <span>{item.value === -1 ? '' : item.display}</span>
                                                                                    {!isNull(item.ColorCode) ? <div className='ar_chekbox-circle me-0' style={{ backgroundColor: item?.ColorCode }}></div> : null}
                                                                                </div>)}

                                                                {props.InsuranceInst === true ?
                                                                    <div className={`list-group__BOX d-block ${styles.ar_all_options}`}>
                                                                        <div className={`text font-m ${styles.insurance_text}`} >
                                                                            {item.value === -1 ? '' : item.display}
                                                                        </div>
                                                                        <p className="text font-m ar-dark-color">Insurance Type: {item.CategoryName ? item.CategoryName : ''}</p>
                                                                        <div className="d-flex align-items-center justify-content-between">
                                                                            <p className="text fs-11 lh-15">Payer ID: {item.PayerID ? item.PayerID : ''}</p>
                                                                            <button className="btn btn-orange h-100 min-w-unset px-2"> {item.PrimaryBillingMethod ? item.PrimaryBillingMethod : ''}</button>
                                                                        </div>
                                                                        {/* <div className="list-group__BOX__item">
                                                                           
                                                                            <p>{item.AddressLine1}{''}</p>
                                                                            <p>{item.AddressLine2}{''}</p>
                                                                            <p>{item.AddressLine2 ? item.City + ', ' : ''}</p>
                                                                            <p>{item.City ? item.State + ' ' : ''}</p>
                                                                            <p>{item.State ? item.ZipCode : ''}</p>

                                                                            <div className="list-group__BOX__item__btns">
                                                                                <button>{item.CategoryName ? item.CategoryName : ''}</button>
                                                                                <button> {item.PrimaryBillingMethod ? item.PrimaryBillingMethod : ''}</button>
                                                                          
                                                                            </div>
                                                                        </div>

                                                                        <div className="list-group__BOX__item">
                                                                            <p className="text-right">{item.PayerID ? item.PayerID : ''}</p>
                                                                        </div> */}
                                                                    </div>
                                                                    : null}
                                                                {props.PatientDeatailedInst === true ?
                                                                    <div className={`d-flex gap-1 align-items-center ${styles.ar_all_options}`}>
                                                                        <div className="circle img-container s-40">
                                                                            <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-male ${isMale(item.Gender) ? 'za-male' : isFemale(item.Gender) ? 'za-female' : 'za-others'}`}>
                                                                                <InitialLetters classes={""} name={item.display} splitBy={','} />
                                                                            </p>
                                                                        </div>
                                                                        <div className='w-100 overflow-hidden'>

                                                                            <div className='d-flex align-items-center'>

                                                                                <div className='d-flex align-items-end gap-1 col-md-9'>
                                                                                    <SearchLetterHighlighted classes={'heading text-nowrap validation_message'} searchValue={props.searchValue} text={item.display} />
                                                                                    <p className='text fs-11 ar-light-color'>{item.DOB} </p>
                                                                                    <p className='text fs-11 ar-light-color'>{item.Age ? <>({item.Age})</> : <></>}</p>
                                                                                    <p className={'text fs-11 ar-light-color'} >{item.Gender}</p>
                                                                                </div>
                                                                                <div className="col-md-3 text-end pe-1">
                                                                                    <SearchLetterHighlighted classes={'text fs-12 fst-italic font-m ar-light-color'} searchValue={props.searchValue} text={item.AccountNumber} />
                                                                                </div>
                                                                            </div>


                                                                            <p className='text font-m fs-11 fst-italic drk-green-clr'>{item.InsuranceName}</p>
                                                                            <div className='d-flex align-items-center'>
                                                                                {item.SubscriberID ?
                                                                                    <div className='d-flex gap-1 col-md-12'>
                                                                                        <p className='text fs-11 text-nowrap'>Subcriber ID:</p>
                                                                                        <SearchLetterHighlighted classes={'text fs-11 text-nowrap validation_message'} searchValue={props.searchValue} text={item.SubscriberID} />
                                                                                    </div> : <></>}

                                                                                {/* {isHomeCareCheck ?
                                                                            <>
                                                                            {item.MedicAidNo ?
                                                                                <div className='d-flex gap-1 col-md-6 justify-content-end'>
                                                                                <p className='text fs-11 font-m text-nowrap'>Medicaid #</p>
                                                                                <SearchLetterHighlighted classes={'text fs-11 font-m text-nowrap validation_message'} searchValue={searchTerm} text={item.MedicAidNo} />
                                                                                </div> : <></>}
                                                                            </>
                                                                            : <></>} */}
                                                                            </div>

                                                                        </div>
                                                                    </div> : null}
                                                            </li>
                                                        </div>

                                            }
                                        </>)
                                    })}
                                </ul>
                            </>
                        }
                    </div>
                ) : null
            }
            {noResponse === true ?
                <div className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX`}>
                    <div className="list-group" id="ul-list-for-auto">
                        <p className={styles.sup_list_group_item} >No Data Found !</p>
                    </div>
                </div>
                : null}
        </div>
    )
}

export default React.memo(SuperSearchList);

export const SearchLetterHighlighted = ({ classes, text, searchValue, type }) => {
    if (!text || text?.length <= 0) return;

    const highlightText = (text, search) => {
        if (type === 'PhoneNumber') {
            if (!search.trim()) return [PhoneNumberFormat(text)]; // Return formatted text as a single segment if search is empty
        } else {
            if (!search.trim()) return [text]; // Return original text as a single segment if search is empty
        }
        // Escape special regex characters in the search string
        const escapedSearch = escapeRegExp(search);
        const regex = new RegExp(`(${escapedSearch})`, 'gi'); // Case-insensitive matching
        if (type === 'PhoneNumber') {
            // Format the entire text
            const formattedText = PhoneNumberFormat(text);
            return formattedText.split(regex).map((part, index) => {
                // Highlight the search term
                return regex.test(part)
                    ? <span className='orange-clr' key={index}>{part}</span>
                    : part;
            });
        } else {
            return text.split(regex).map((part, index) => regex.test(part) ? <span className='orange-clr' key={index}>{part}</span> : part)
        }
    };

    const escapeRegExp = (string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
    };

    const segments = highlightText(text, searchValue);
    return (
        <p className={classes} title={text}>
            {segments}
        </p>
    );
}
export const PhoneNumberFormat = (number) => {
    if (!number) return;
    const formattedValue = number.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    return !formattedValue[2] ? formattedValue[1] : `(${formattedValue[1]}) ${formattedValue[2]}${formattedValue[3] ? '-' + formattedValue[3] : ''}`;
}